import React from "react"
import {
  NavItem,
  NavLink,
  UncontrolledDropdown,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Media,
  Badge,
  Button,
  FormGroup,
  //Form,
  Row,
  Col,
  //Input,
  Label,
  Modal, ModalHeader, ModalBody, ModalFooter, Tooltip, InputGroup
} from "reactstrap"
import Select from "react-select"
import PerfectScrollbar from "react-perfect-scrollbar"
import axios from "axios"
import * as Icon from "react-feather"
import classnames from "classnames"
import Autocomplete from "../../../components/@vuexy/autoComplete/AutoCompleteComponent"
import { history } from "../../../history"
import { connect } from "react-redux"
import ReactCountryFlag from "react-country-flag"
import { IntlContext } from "../../../utility/context/Internationalization"
import Avatar from "../../../components/DSA/Avatar"
import moment from 'moment'
import { startApp, arrival, departure, interruption, interruptionEnd, pauseWork } from "../../../redux/actions/activity/activityActions"
import { getTasksAll } from '../../../redux/actions/todo/index'
import { startWork, endWork } from "../../../redux/actions/activity/activityActions"
import firebase from "firebase/app"
import { } from "firebase/auth"
import { } from "firebase/database"
import { firebaseConfig } from "../../../authServices/firebaseConfig"
import Checkbox from "../../../components/@vuexy/checkbox/CheckboxesVuexy"
import { Check } from "react-feather"
import DateTime from "../../../components/DSA/DateTime"
import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
import { FormattedMessage } from 'react-intl'
import CompleteModal from "../../../views/pages/todo/components/CompleteModal"
import PixSelect from "../../../components/Pixacom/PixSelect"
import Tasks from "./Tasks";
import { loginSwitchUser } from '../../../redux/actions/auth/loginActions';


function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const BLN = [
  /*{ value: 1, label: 'HEMS - letecké záchrané složky' },
  { value: 2, label: 'L - letecká škola ATO' },
  { value: 3, label: 'S - kancelářské práce' },
  { value: 4, label: 'A - dopravní ATX/OLD' },
  { value: 5, label: 'SC - služební cesta' },
  { value: 6, label: 'O - odpočinek' },
  { value: 7, label: 'D - dovolená' },*/
  { value: 8, label: 'Vybrat směnu' }
]

class NavbarUser extends React.PureComponent {
  state = {
    object: { feature: false, fullDay: false },
    navbarSearch: false,
    suggestions: [],
    notifications: [],
    notificationCount: 0,
    notificationAPI: '/api/Notification/New',
    config: { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
    modalInterruption: false,
    interruptionTypeSelect: [],
    isFeatureInterruption: false,
    begin: moment(),
    end: moment().add(1, 'd'),
    tooltipOpen: false,
    lastActivity: null,
    modalComplete: false,
    callbackModal: null,
    modalWork: false,
    modalWorkTodo: false,
    workID: null,
    todos: [],
    changeUser: false,
    userForChange: null
  }

  async componentDidMount() {
    /*axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })*/

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    // Get a reference to the database service
    this.database = firebase.database();
    let _this = this;
    firebase.database().ref('/users/' + this.props.user.id + '/notifications').once('value').then(function (snapshot) {
      _this.updateNotifications(snapshot.val());
    })

    // ready to receive new
    var notificationsRef = firebase.database().ref('/users/' + this.props.user.id + '/notifications');
    notificationsRef.on('value', function (snapshot) {
      _this.updateNotifications(snapshot.val());
    });

    if (this.props.user) {
      await this.props.startApp()
      this.getActivityType();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activity.lastActivity !== this.props.activity.lastActivity) {
      this.setState({ lastActivity: this.props.activity.lastActivity });
    }
  }

  componentWillReceiveProps(nextProps) {
    /*if (nextProps.user === undefined || nextProps.user === "") {
      history.push("/login");
    }*/
  }

  notificationReaded = async (guid) => {
    firebase.database().ref('users/' + this.props.user.id + '/notifications/' + guid).update({ readed: true });

    var response = await axios.get("/api/notification/guid/" + guid, this.state.config);
    if (response.data) {
      var notification = response.data;
      notification.readed = true;
      await axios.put("/api/notification/" + notification.id, notification, this.state.config);
    }
  }

  getActivityType = async () => {
    axios.get("/api/Activity/Type/", this.state.config).then(response => {
      if (response.data !== undefined) {
        let rowData = [];
        response.data.forEach(obj => {
          let rowLabel = obj.code + " | " + obj.name;
          rowData.push(
            {
              label: rowLabel,
              value: obj.id
            }
          )
        });
        rowData = rowData.sort((a, b) => {
          if (a.label < b.label) return -1;
          if (a.label > b.label) return 1;
          return 0;
        })

        this.setState({ interruptionTypeSelect: rowData })
      }
    }).catch()
  }

  updateNotifications(notifications) {
    var count = 0;
    var newState = [];
    for (var guid in notifications) {
      var notification = notifications[guid];
      notification.guid = guid;
      if (!notification.readed) count++;

      if (!notification.deleted)
        newState.push(notification);
    }

    function compare(a, b) {
      if (a.send < b.send) {
        return 1;
      }
      if (a.send > b.send) {
        return -1;
      }
      return 0;
    }

    newState.sort(compare);
    newState = newState.slice(0, 5);
    this.setState({ notifications: newState, notificationCount: count })
  }

  getNotifications() {
    axios.get(this.state.notificationAPI, this.state.config).then((response) => {
      if (response.data !== undefined) {
        /*let rowData = [];
        response.data.map(obj => {
          let rowLabel = (obj.name);
            rowData.push(
                {
                    label: rowLabel,
                    value: obj.id
                }
            )
        });*/
        this.setState({ notifications: response.data })
      }
    }).catch(e =>
      toast.error("Chyba při načítání notifikací!")
    )
  }

  handleChange = (event) => {
    let name = event.target.name + "";
    let value = (event.target.type === "number") ? Number(event.target.value) : ((event.target.type === "checkbox") ? event.target.checked : event.target.value);

    if (name.includes(".")) {
      let name2 = name.split(".");
      let namex0 = name2[0];
      let namex1 = name2[1];
      let x = this.state.object[namex0];
      if (x === undefined) {
        x = {};
      }
      x[namex1] = value;
      let object = this.state.object;
      object[namex0] = x;

      this.setState(object);
    } else {
      this.setState(prevState => {
        prevState = JSON.parse(JSON.stringify(this.state.object));
        prevState[name] = value;

        if (name === "feature" && value) {
          prevState['fullDay'] = true;
        }

        console.log(prevState);

        return { object: prevState }
      })
    }
  }
  handleChangeDate = (event) => {
    let name = event.target.name + "";
    let value = (event.target.type === "number") ? Number(event.target.value) : ((event.target.type === "checkbox") ? event.target.checked : event.target.value);

    if (name.includes(".")) {
      let name2 = name.split(".");
      let namex0 = name2[0];
      let namex1 = name2[1];
      let x = this.state.object[namex0];
      if (x === undefined) {
        x = {};
      }
      x[namex1] = value;
      let object = this.state.object;
      object[namex0] = x;

      this.setState(object);
    } else {
      this.setState(prevState => {
        prevState = JSON.parse(JSON.stringify(this.state.object));
        prevState[name] = value;
        return { object: prevState }
      })
    }
  }
  handleChangeDateRange = (dates) => {
    this.setState(prevState => {
      prevState = JSON.parse(JSON.stringify(this.state.object));
      prevState["begin"] = dates[0];
      prevState["end"] = dates[1];
      return { object: prevState }
    })
  }
  handleChangeSelector = (event, propName) => {
    let name = propName;
    let value = event.value;

    if (name.includes(".")) {
      let name2 = name.split(".");
      let namex0 = name2[0];
      let namex1 = name2[1];
      let x = this.state.object[namex0];
      if (x === undefined) {
        x = {};
      }
      x[namex1] = value;
      let object = this.state.object;
      object[namex0] = x;

      this.setState(object);
    } else {
      this.setState(prevState => {
        prevState = JSON.parse(JSON.stringify(this.state.object));
        prevState[name] = value;

        return { object: prevState }
      })
    }
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }

  handleLangDropdown = () =>
    this.setState({ langDropdown: !this.state.langDropdown })

  toggleModalInterruption = () => {
    this.setState(prevState => ({
      modalInterruption: !prevState.modalInterruption
    }), () => {
      if (this.state.modalInterruption) {
        this.setState({});
      }
    })
  }

  toggleModalWork = () => {
    this.setState(prevState => ({
      modalWork: !prevState.modalWork
    }), () => {
      if (this.state.modalWork) {
        this.setState({});
      }
    })
  }

  toggleModalWorkTodo = async () => {
    let tmp = await this.props.getTasksAll('today', false)
    console.log();

    let todos = [];
    if (!this.state.modalWorkTodo) {
      //todos = await this.props.getTasksAll('today', false);
    }

    this.setState(prevState => ({
      todos: todos,
    }), () => {
      this.setState(prevState => ({ modalWorkTodo: !prevState.modalWorkTodo }));
    })
  }

  departure = async () => {
    if (this.props.activity.onInterruption) {
      await this.props.interruptionEnd(this.props.activity.lastActivity);
    }
    if (this.props.activity.working) {
      await this.props.pauseWork(this.props.activity.lastActivity);
    }

    this.props.departure();
  }

  createTask = async (id) => {
    let response = await axios.post('/api/Task/Generate/' + this.state.workID, null, this.state.config);

    await this.props.startWork(response.data.id, this.props.activity.lastActivity);
  }

  // Notifications
  sendNotification = async () => {
    let result = await axios.get("/api/Person/", this.state.config);

    if (result.data === null) return;

    let veisID = null;
    let person = this.props.user.person;
    result.data.forEach(x => {
      if (x.surName === "Veisová" && x.firstName === "Ivana") {
        veisID = x.userID;
      }
    });

    var guid = uuidv4();
    let text = "Uživatel " + person.surName + " naplánoval budoucí přerušení.";
    var notification = { guid: guid, title: "Nové přerušení", text: text, form: "/office/activity/", send: moment().format(), personID: person.id, delivered: true }
    await axios.post("/api/Notification/", notification, this.state.config);

    firebase.database().ref('users/' + veisID + '/notifications/' + guid).set({
      subject: "Nové přerušení",
      text: text,
      form: "/office/activity/",
      send: moment().format(),
      readed: false
    }, async function (error) {
      if (error) {
        // The write failed...
      } else {
        // Data saved successfully!
      }
    });
  }

  toggleTooltip = () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  }

  toggleModalComplete = (callback = null) => {
    this.setState({ modalComplete: !this.state.modalComplete, callbackModal: callback });
  }

  render() {
    const UserDropdown = props => {
      return (
        <DropdownMenu right>
          <DropdownItem tag="a" href="#"
            onClick={e => {
              e.preventDefault()
              history.push("/pages/userSetting")
            }}>
            <Icon.User size={14} className="mr-50" />
            <span className="align-middle">
              <FormattedMessage
                id="Edit Profile"
                defaultMessage="Edit Profile"
                values={{}}
              />
            </span>
          </DropdownItem>

          <DropdownItem divider />

          {this.props.user?.roles?.includes('Superuser') &&
            <DropdownItem tag="a" href="#"
              onClick={e => {
                e.preventDefault();
                this.setState({ changeUser: true });
              }}>
              <Icon.User size={14} className="mr-50" />
              <span className="align-middle">
                Switch user
              </span>
            </DropdownItem>
          }

          <DropdownItem
            tag="a"
            href="#"
            onClick={e => {
              e.preventDefault()
              return props.logoutWithEmail()
            }}
          >
            <Icon.Power size={14} className="mr-50" />
            <span className="align-middle">
              <FormattedMessage
                id="Log Out"
                defaultMessage="Log Out"
                values={{}}
              />
            </span>
          </DropdownItem>
        </DropdownMenu>
      )
    }

    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <CompleteModal
          toggleModalComplete={this.toggleModalComplete}
          modalComplete={this.state.modalComplete}
          itemToComplete={this.state.lastActivity?.task}
          //onSubmit={ this.state.callbackModal }
          onSubmit={this.state.callbackModal}
        />


        {/* Switch */}
        <Modal
          isOpen={this.state.changeUser}
          toggle={() => this.setState(prevState => { return { changeUser: !prevState } })}
          className="modal-dialog-centered"
        >
          <ModalHeader toggle={() => this.setState(prevState => { return { changeUser: !prevState } })}>
            Výběr uživatele
          </ModalHeader>
          <ModalBody>

            <Row>
              <Col md="12" sm="12">
                <FormGroup className="form-label-group" >
                  <Label>Uživatel</Label>
                  <PixSelect
                    id='userID'
                    name='userID'
                    placeholder='Vyberte odpovědnou osobu'
                    className='w-100'
                    apiLink='/api/user'
                    labelFormat={item => item.person.surName + ' ' + item.person.firstName}
                    onChange={value => this.setState({ userForChange: value })}
                    editID={this.state.userForChange}
                  />
                </FormGroup>
              </Col>
            </Row>

          </ModalBody>
          <ModalFooter>
            <Button.Ripple
              color="primary"
              type="submit"
              className="mr-1 mb-1"
              onClick={async (e) => {
                e.preventDefault();
                this.props.loginSwitchUser(this.state.userForChange);
                this.setState({ changeUser: false });
              }}
            >
              Přepnout
            </Button.Ripple>
            <Button.Ripple
              color="warning"
              type="submit"
              className="mr-1 mb-1"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ changeUser: false });
              }}
            >
              Zrušit
            </Button.Ripple>
          </ModalFooter>
        </Modal>

        {/* Přerušení */}
        <Modal
          isOpen={this.state.modalInterruption}
          toggle={this.toggleModalInterruption}
          className="modal-dialog-centered"
        >
          <ModalHeader toggle={this.toggleModalInteruption}>
            Výběr přerušení
          </ModalHeader>
          <ModalBody>
            {this.state.lastActivity?.activityType === 3 &&
              <Row>
                <Col sm='12'>
                  <FormGroup className="form-label-group" >
                    <p className='danger'>Pro spuštění přerušení je potřeba nejprve ukončit úkol, který právě plníte. (Netýká se budoucího přerušení)</p>
                    <p>Právě plníte úkol <b>{this.state.lastActivity?.task?.subject}</b>&nbsp;
                      <Button.Ripple
                        outline
                        size='sm'
                        color="primary"
                        type="submit"
                        className="mr-1 mb-1"
                        onClick={(e) => { e.preventDefault(); this.toggleModalComplete(); }}
                      >
                        Ukončit úkol
                      </Button.Ripple>
                    </p>
                  </FormGroup>
                </Col>
              </Row>
            }
            <Row>
              <Col md="12" sm="12">
                <FormGroup className="form-label-group" >
                  <Label for="interruptionType">Typ přerušení</Label>
                  <Select
                    styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                    placeholder="Vyberte typ přerušení"
                    id="interruptionType"
                    name="interruptionType"
                    required={true} s
                    onChange={e => this.handleChangeSelector(e, "interruptionType")}
                    options={this.state.interruptionTypeSelect.map(object => {
                      return { value: object.value, label: object.label, category: object.category }
                    })}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6" sm="12">
                <FormGroup className="form-label-group" >
                  <Checkbox
                    name="feature"
                    id="feature"
                    icon={<Check className="vx-icon" size={16} />}
                    label="Budoucí přerušení"
                    onChange={this.handleChange}
                    defaultChecked={false}
                    checked={this.state.object.feature}
                  />
                </FormGroup>
              </Col>
              {this.state.object.feature
                ?
                <Col md="6" sm="12">
                  <FormGroup className="form-label-group" >
                    <Checkbox
                      name="fullDay"
                      id="fullDay"
                      icon={<Check className="vx-icon" size={16} />}
                      label="Celý den"
                      onChange={this.handleChange}
                      defaultChecked={true}
                      checked={this.state.object.fullDay}
                    />
                  </FormGroup>
                </Col>
                : null
              }
            </Row>

            {this.state.object.feature
              ?
              <Row>
                {this.state.object.fullDay !== true ?
                  <Col md="6" sm="12">
                    <FormGroup className="form-label-group">
                      <Label for="begin" className={"label-top"}>Začátek</Label>
                      <DateTime
                        id={"begin"}
                        name={"begin"}
                        value={this.state.object.begin ? moment(this.state.object.begin).format("HH:mm DD.MM.YYYY") : null}
                        className="form-control"
                        onChange={(date, dateStr) => this.handleChangeDate({ target: { name: "begin", type: 'date', value: date.length ? date[0] : date } })}
                        options={{ altInput: true, altFormat: "H:i d.m.Y", enableTime: true, time_24hr: true, dateFormat: "H:i d.m.Y" }}
                      />
                    </FormGroup>
                  </Col>
                  : null}
                {this.state.object.fullDay !== true ?
                  <Col md="6" sm="12">
                    <FormGroup className="form-label-group">
                      <Label for="end" className={"label-top"}>Konec</Label>
                      <DateTime
                        id={"end"}
                        name={"end"}
                        value={this.state.object.end ? moment(this.state.object.end).format("HH:mm DD.MM.YYYY") : null}
                        className="form-control"
                        onChange={(date, dateStr) => this.handleChangeDate({ target: { name: "end", type: 'date', value: date.length ? date[0] : date } })}
                        options={{ altInput: true, altFormat: "H:i d.m.Y", enableTime: true, time_24hr: true, dateFormat: "H:i d.m.Y" }}
                      />
                    </FormGroup>
                  </Col>
                  : null}
                {this.state.object.fullDay === true &&
                  <Col md="12" sm="12">
                    <FormGroup className="form-label-group">
                      <Label for="begin" className={"label-top"}>Rozmezí</Label>
                      <DateTime
                        id={"begin"}
                        name={"begin"}
                        value={[this.state.object.begin ? moment(this.state.object.begin).format("DD.MM.YYYY") : null, this.state.object.end ? moment(this.state.object.end).format("DD.MM.YYYY") : null]}
                        className="form-control"
                        onChange={(date, dateStr) => this.handleChangeDateRange(date)}
                        options={{ altInput: true, mode: "range", altFormat: "d.m.Y", enableTime: false, time_24hr: true, dateFormat: "d.m.Y" }}
                      />
                    </FormGroup>
                  </Col>
                }
              </Row>
              : null
            }

          </ModalBody>
          <ModalFooter>
            <Button.Ripple
              disabled={!this.state.object.interruptionType && (this.state.lastActivity?.activityType !== 3 || this.state.isFeatureInterruption)}
              color="primary"
              type="submit"
              className="mr-1 mb-1"
              onClick={async (e) => {
                e.preventDefault();
                this.toggleModalInterruption();

                if (this.state.object.begin !== undefined && this.state.object.end !== undefined && this.state.object.begin !== null && this.state.object.end !== null) {
                  toast.success("Budoucí přerušení bylo uloženo.");
                  await this.props.interruption(this.state.object.interruptionType, this.state.object.begin, this.state.object.end);
                  this.state.object.begin = null;
                  this.state.object.end = null;
                  await this.sendNotification();
                }
                else {
                  await this.props.interruption(this.state.object.interruptionType, null, null, this.props.activity?.lastActivity);
                }

                this.setState({ isFeatureInterruption: false, isFullDay: false });
              }}
            >
              Uložit
            </Button.Ripple>
            <Button.Ripple
              color="warning"
              type="submit"
              className="mr-1 mb-1"
              onClick={(e) => { e.preventDefault(); this.setState({ isFeatureInterruption: false, isFullDay: false }); this.toggleModalInterruption(); }}
            >
              Zrušit
            </Button.Ripple>
          </ModalFooter>
        </Modal>

        {/* Práce */}
        <Modal
          isOpen={this.state.modalWork}
          toggle={this.toggleModalWork}
          className="modal-dialog-centered"
        >
          <ModalHeader toggle={this.toggleModalWork}>
            Začít směnu
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md="12" sm="12">
                <InputGroup>
                  <Label>Typ práce</Label>
                  <PixSelect
                    id='workID'
                    name='workID'
                    placeholder='Vyberte typ práce'
                    className='w-100'
                    required={true}
                    data={BLN}
                    onChange={value => {
                      this.setState({ workID: value }, async () => {
                        if (value === 8) {
                          await this.toggleModalWorkTodo();
                        }
                      })
                    }}
                    editID={this.state.workID}
                  />
                </InputGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button.Ripple
              disabled={this.state.workID === null || this.state.workID === 8}
              color="primary"
              type="submit"
              className="mr-1 mb-1"
              onClick={async (e) => {
                e.preventDefault();
                this.createTask();
                this.toggleModalWork();
              }}
            >
              Uložit
            </Button.Ripple>
            <Button.Ripple
              color="warning"
              type="submit"
              className="mr-1 mb-1"
              onClick={(e) => { e.preventDefault(); this.toggleModalWork(); }}
            >
              Zrušit
            </Button.Ripple>
          </ModalFooter>
        </Modal>

        {/* Práce */}
        <Modal
          isOpen={this.state.modalWorkTodo}
          toggle={this.toggleModalWorkTodo}
          className="modal-dialog-centered"
          size='lg'
        >
          <ModalHeader toggle={this.toggleModalWorkTodo}>
            Začít směnu
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md="12" sm="12">
                {this.state.todos &&
                  <Tasks
                    tasks={this.props.store.tasks}
                    tasksFiltered={this.props.store.tasks}
                    filter={this.props.store.params.filter}
                    toggleModal={this.toggleModalWorkTodo}
                    toggleModalParrent={this.toggleModalWork}
                  />
                }
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button.Ripple
              color="warning"
              type="submit"
              className="mr-1 mb-1"
              onClick={(e) => { e.preventDefault(); this.toggleModalWorkTodo(); }}
            >
              Zrušit
            </Button.Ripple>
          </ModalFooter>
        </Modal>

        <IntlContext.Consumer>
          {context => {
            let langArr = {
              "cs": "Česky",
              "en": "English"
            }
            return (
              <Dropdown
                tag="li"
                className="dropdown-language nav-item"
                isOpen={this.state.langDropdown}
                toggle={this.handleLangDropdown}
                data-tour="language"
              >
                <DropdownToggle
                  tag="a"
                  className="nav-link"
                >
                  <ReactCountryFlag
                    className="country-flag"
                    countryCode={
                      context.state.locale === "en"
                        ? "us"
                        : context.state.locale === "cs" ? "cz" : context.state.locale
                    }
                    svg
                  />
                  <span className="d-sm-inline-block d-none text-capitalize align-middle ml-50">
                    {langArr[context.state.locale]}
                  </span>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    tag="a"
                    onClick={e => context.switchLanguage("cs")}
                  >
                    <ReactCountryFlag className="country-flag" countryCode="cz" svg />
                    <span className="ml-1">Česky</span>
                  </DropdownItem>
                  <DropdownItem
                    tag="a"
                    onClick={e => context.switchLanguage("en")}
                  >
                    <ReactCountryFlag className="country-flag" countryCode="us" svg />
                    <span className="ml-1">English</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )
          }}
        </IntlContext.Consumer>

        {
          this.props.user &&
          <UncontrolledDropdown
            tag="li"
            className="dropdown-notification nav-item"
          >
            <DropdownToggle tag="a" className="nav-link nav-link-label">
              <Icon.Bell size={21} />
              {this.state.notificationCount > 0 &&
                <Badge pill color="danger" className="badge-up">
                  {" " + this.state.notificationCount + " "}
                </Badge>
              }
            </DropdownToggle>
            <DropdownMenu tag="ul" right className="dropdown-menu-media">
              <li className="dropdown-menu-header">
                <div className="dropdown-header mt-0">
                  <h3 className="text-white">
                    {this.state.notificationCount === 0 && "žádné nové"}
                    {this.state.notificationCount > 0 && this.state.notificationCount < 5 && this.state.notificationCount + " nové"}
                    {this.state.notificationCount > 4 && this.state.notificationCount + " nových"}
                  </h3>
                  <span className="notification-title">Notifikace</span>
                </div>
              </li>
              <PerfectScrollbar
                className="media-list overflow-hidden position-relative"
                options={{
                  wheelPropagation: false
                }}
              >
                {this.state.notifications && this.state.notifications.map((notification) => {
                  return (
                    <div className={(!notification.readed ? "bg-light-danger " : "") + "d-flex justify-content-between"} onClick={e => { e.preventDefault(); this.notificationReaded(notification.guid); if (notification.form) { history.push(notification.form); } else { history.push("/notificationcenter/inbox"); } document.body.click(); }}>
                      <Media className="d-flex align-items-start">
                        {!notification.readed &&
                          <Media left href="#">
                            <Badge pill color="danger" className="badge"><FormattedMessage id="New" defaultMessage="New" /></Badge>
                            {/*<Icon.PlusSquare
                          className="font-medium-5 primary"
                          size={21}
                        />*/}
                          </Media>}
                        <Media body>
                          <Media heading className={(!notification.readed ? "danger" : "primary") + " media-heading"} tag="h6">
                            {notification.subject}
                          </Media>
                          <p className="notification-text" dangerouslySetInnerHTML={{ __html: notification.text }}>
                            {/*notification.text ? (notification.text.length > 25 ? notification.text.substring(0, 25)+"..." : notification.text) : ""*/}
                          </p>
                        </Media>
                        <small>
                          <time
                            className="media-meta"
                            dateTime={notification.send/*"2015-06-11T18:29:20+08:00"*/}
                          >
                            {moment(notification.send).fromNow()}
                          </time>
                        </small>
                      </Media>
                    </div>
                  )
                })}
              </PerfectScrollbar>
              <li className="dropdown-menu-footer" onClick={e => { e.preventDefault(); history.push("/notificationcenter/inbox"); }}>
                <DropdownItem tag="a" className="p-1 text-center">
                  <span className="align-middle"><FormattedMessage id="Read all notifications" defaultMessage="Read all notifications" values={{}} /></span>
                </DropdownItem>
              </li>
            </DropdownMenu>
          </UncontrolledDropdown>
        }
        {
          this.props.user &&
          <UncontrolledDropdown tag="li" className="dropdown-activity nav-item">
            <DropdownToggle tag="a" className="nav-link nav-link-label">
              {/*console.log(this.props.app.todo.todos.forEach(x => {if(x.id === this.props.activity.lastActivity.TaskID) return x;}))*/}
              {this.props.activity.lastActivity?.activityType === 0 &&
                <Badge pill color="success" className="badge" id="hoverWork">&nbsp;V práci&nbsp;</Badge>
              }
              {this.props.activity.lastActivity?.activityType === 2 &&

                <React.Fragment>
                  <Badge pill color="warning" className="badge" id="hoverInter">&nbsp;Přerušení&nbsp;</Badge>
                  <Tooltip placement="left" isOpen={this.state.tooltipOpen} target="hoverInter" toggle={this.toggleTooltip}>
                    {this.state.lastActivity?.activityInterruptionType?.name}
                  </Tooltip>
                </React.Fragment>
              }
              {this.props.activity.lastActivity?.activityType === 3 &&
                <React.Fragment>
                  <Badge pill color="danger" className="badge" id="hoverAtWork">&nbsp;Práce&nbsp;</Badge>
                  <Tooltip placement="left" isOpen={this.state.tooltipOpen} target="hoverAtWork" toggle={this.toggleTooltip}>
                    {this.state.lastActivity?.task?.subject}
                  </Tooltip>
                </React.Fragment>
              }
              &nbsp;
              <Icon.UserCheck size={21} />
            </DropdownToggle>
            <DropdownMenu right>
              {this.props.activity.lastActivity?.activityType === 1 &&
                <DropdownItem tag="a" href="#"
                  onClick={async e => {
                    e.preventDefault();
                    await this.props.arrival();
                  }}>
                  <span className="align-left">Příchod</span>
                </DropdownItem>
              }

              {this.props.activity.lastActivity?.activityType !== 1 &&
                <DropdownItem tag="a" href="#"
                  onClick={e => {
                    e.preventDefault()
                    if (this.state.lastActivity?.activityType === 3) {
                      this.toggleModalComplete(this.departure);
                    }
                    else {
                      this.departure();
                    }
                  }}>
                  <span className="align-middle">Odchod</span>
                </DropdownItem>
              }

              {this.props.activity.lastActivity?.activityType !== 3 && this.props.activity.lastActivity?.activityType !== 2 &&
                <DropdownItem tag="a" href="#"
                  onClick={e => {
                    e.preventDefault()
                    this.toggleModalWork();
                  }}>
                  <span className="align-middle"><b>Začít práci</b></span>
                </DropdownItem>
              }

              {this.props.activity.lastActivity?.activityType === 3 &&
                <DropdownItem tag="a" href="#"
                  onClick={e => {
                    e.preventDefault()
                    this.toggleModalComplete();
                  }}>
                  <span className="align-middle"><b>Ukončit práci</b></span>
                </DropdownItem>
              }

              {this.props.activity.lastActivity?.activityType !== 2 &&
                <DropdownItem tag="a" href="#"
                  onClick={e => {
                    e.preventDefault()
                    this.toggleModalInterruption()
                  }}>
                  <span className="align-middle"><b>Přerušení</b></span>
                </DropdownItem>
              }

              {this.props.activity.lastActivity?.activityType === 2 && this.props.activity.lastActivity?.feature &&
                <DropdownItem tag="a" href="#"
                  onClick={async e => {
                    e.preventDefault();
                    await this.props.interruptionEnd(this.props.activity.lastActivity);
                  }}>
                  <span className="align-middle"><b>Ukončit přerušení</b></span>
                </DropdownItem>
              }

              <DropdownItem tag="a" href="#"
                onClick={e => {
                  e.preventDefault()
                  history.push("/office/activity");
                }}>
                <span className="align-middle"><b>Přehled</b></span>
              </DropdownItem>

            </DropdownMenu>
          </UncontrolledDropdown>
        }
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {/*this.props.userName*/}
                {this.props.user.person ? this.props.user.person.surName + " " + this.props.user.person.firstName : this.props.user.userName === undefined ? "" : this.props.user.userName.split('@')[0]}
              </span>
              <span className="user-status">{this.props.user.person ? this.props.user.person.email : ""}</span>
            </div>
            <span data-tour="user">
              {this.props.user && this.props.user.person && <Avatar className="mr-1" id={this.props.user.avatar === true ? this.props.user.id : null} color={this.props.user.avatarColor ? this.props.user.avatarColor : "primary"} content={this.props.user.person.surName + " " + this.props.user.person.firstName} />}
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.auth.login.user,
    activity: state.activity.action,
    app: state.todoApp,
    store: state.todoApp
  }
}
export default connect(mapStateToProps, {
  startApp,
  arrival,
  departure,
  interruption,
  interruptionEnd,
  pauseWork,
  getTasksAll,
  startWork,
  loginSwitchUser
})(NavbarUser)
